import { Token, VTokenBalance, Vault, Zero, addressEqual } from 'nftx.js';
import { SwapState } from './types';

const getMintableVTokens = ({
  balances,
  filterController,
  buyType,
  buyToken,
  vaults,
  buyVaultId,
}: {
  balances: VTokenBalance[] | undefined;
  vaults: Vault[] | undefined;
} & Pick<
  SwapState,
  'filterController' | 'buyType' | 'buyToken' | 'buyVaultId'
>) => {
  const vTokens: Array<{ vaultId: string; balance: bigint } & Token> = [];

  vaults?.forEach((vault) => {
    const balance =
      balances?.find((x) => x.vaultId === vault.vaultId)?.balance ?? Zero;

    // If we're buying ETH we can sell any vToken
    // If we're buying vTokens we can sell any other vToken
    if (filterController === 'buy' && buyType === 'vTOKEN' && buyToken) {
      if (addressEqual(buyToken, vault.id)) {
        // Can't buy the same vToken
        return;
      }
    }
    // If we're buying NFTs then we can only sell vTokens from the same vault
    if (filterController === 'buy' && buyType === 'NFT' && buyVaultId) {
      if (buyVaultId !== vault.vaultId) {
        return;
      }
    }
    vTokens.push({
      balance,
      id: vault.id,
      name: vault.token.name,
      symbol: vault.token.symbol,
      vaultId: vault.vaultId,
    });
  });

  return vTokens;
};

export default getMintableVTokens;
